import { FToastInQa } from '@/sub-luca-plugin/types';
import { createContext } from 'react';

export const QaRecordsContext = createContext<{ getQaStoreByContext?: any; toastInQa?: FToastInQa }>({});
